<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
    breastFeeding: {
        type: Boolean,
        default: false,
    },
    dietarySupplement: {
        type: Boolean,
        default: false,
    },
    freelyAvailableMedicine: {
        type: Boolean,
        default: false,
    },
    hygienic: {
        type: Boolean,
        default: false,
    },
    expiration: {
        type: Boolean,
        default: false,
    },
})

const showMessage = computed(() => {
    return props.breastFeeding || props.freelyAvailableMedicine || props.dietarySupplement || props.hygienic || props.expiration
})
</script>

<template>
    <div
        v-if="showMessage"
        class="attribute-warning-message"
        :class="{
            pink: breastFeeding,
            green: freelyAvailableMedicine,
            purple: dietarySupplement,
            hygienic: hygienic,
            expiration: expiration,
        }"
    >
        <template v-if="breastFeeding">
            <img
                class="attribute-warning-message__img"
                src="/nuxt-assets/icons/breast-feeding.svg"
                :alt="$t('productDetail.tabs.breastFeeding.title')"
            />
            <div>
                <strong>{{ $t('productDetail.tabs.breastFeeding.title') }}</strong>
                {{ $t('productDetail.tabs.breastFeeding.text') }}
            </div>
        </template>
        <template v-else-if="freelyAvailableMedicine">
            <img
                class="attribute-warning-message__img"
                src="/nuxt-assets/icons/freely-available-medicine.svg"
                :alt="$t('productDetail.tabs.freelyAvailableMedicine.title')"
            />
            <div>
                <strong>{{ $t('productDetail.tabs.freelyAvailableMedicine.title') }}</strong>
                {{ $t('productDetail.tabs.freelyAvailableMedicine.text') }}
            </div>
        </template>
        <template v-else-if="dietarySupplement">
            <img
                class="attribute-warning-message__img"
                src="/nuxt-assets/icons/dietary-supplement.svg"
                :alt="$t('productDetail.tabs.dietarySupplement.title')"
            />
            <div>
                <strong>{{ $t('productDetail.tabs.dietarySupplement.title') }}</strong>
                {{ $t('productDetail.tabs.dietarySupplement.text') }}
            </div>
        </template>
        <template v-else-if="hygienic">
            <img
                class="attribute-warning-message__img"
                src="/nuxt-assets/icons/hygienic-warning.svg"
                width="48"
                height="31"
                :alt="$t('productDetail.tabs.hygienic.title')"
            />
            <div>
                <strong>{{ $t('productDetail.tabs.hygienic.title') }}</strong>
                {{ $t('productDetail.tabs.hygienic.text') }}
            </div>
        </template>
        <template v-else-if="expiration">
            <div>
                <strong>{{ $t('productDetail.tabs.shortExpiryDate.title') }}</strong>
                {{ $t('productDetail.tabs.shortExpiryDate.text') }}
            </div>
        </template>
    </div>
</template>

<style lang="scss" scoped>
.attribute-warning-message {
    padding: 1.5rem;
    border-radius: $rounded;
    text-align: center;
    margin-bottom: 1.5rem;

    &.pink {
        background: $color-cta-extra-light;
        color: $color-cta;
    }

    &.purple {
        background: $color-purple-light;
        color: $color-purple-dark;
    }

    &.green {
        background: $color-green-light;
        color: $color-green-dark;
    }

    &.hygienic {
        background: $color-alert-light;
        color: $color-alert;
    }

    &.expiration {
        background: $color-alert-light;
        color: $color-alert;
    }

    @media (min-width: 500px) {
        display: flex;
        gap: 1rem;
        text-align: left;
        align-items: center;
        align-content: center;
    }

    &__img {
        margin-bottom: 1rem;
        max-width: 48px;
        max-height: 31px;

        @media (min-width: 500px) {
            margin-bottom: 0;
        }
    }
}
</style>
